import { render } from "./ProjectHomeDetails.vue?vue&type=template&id=0d571eb8"
import script from "./ProjectHomeDetails.vue?vue&type=script&lang=js"
export * from "./ProjectHomeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__